import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'usb-event-rate-mannager',
  templateUrl: './event-rate-mannager.component.html',
  styleUrls: ['./event-rate-mannager.component.scss']
})
export class EventRateMannagerComponent implements OnInit {
  agencyInfo: any;
  infoEventRate: any[] = [];
  title: string = '';
  mannagementOption: string = '';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  constructor(
                private homeService: HomeService,
                private activatedRoute: ActivatedRoute,
                public toasrt: ToastrService

              ) { }

  ngOnInit(): void {
    const selectedAgency = localStorage.getItem('selectedAgency');
    this.agencyInfo = JSON.parse(selectedAgency);
    this.suscriptionParam();

  }

  suscriptionParam(): void {
    this.activatedRoute.params
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(params => {

          let infoUrl: any;

          this.mannagementOption = params['mannagementOption'];

          if(this.mannagementOption) {
            infoUrl = this.getDataAgencyInfo(this.mannagementOption);
            this.getDataMannager(infoUrl);
          }

        });
  }

  getDataAgencyInfo(routeParam: string): any {

    let paramsUrl = {};

    paramsUrl = this.paramsUrlInit();

    switch(routeParam) {

      case 'circuit':
        paramsUrl['type'] = 1;
        break;
      case 'rate':
        paramsUrl['type'] = 2;
        break;
      case 'tools':
        paramsUrl['type'] = 3;
        break;
      case 'national':
        paramsUrl['type'] = 4;
        break;
      case 'deals':
        paramsUrl['type'] = 5;
        break;

    }

    return paramsUrl;
  }

  paramsUrlInit(): any {
    return {
      channel: this.agencyInfo?.channel_id === 2 ? 'minorista' : 'mayorista',
      location_agency_id: this.agencyInfo?.location_agency_id === 1 ? 'exterior' : 'exterior',
      language: this.agencyInfo?.language === 39 ? 1 : 2,
    }
  }


  getDataMannager(infoAgency: any): void {
    this.homeService.ratesInfo(infoAgency).subscribe({
      next: (res: any) => {
        console.log(res);
        if(res) {
          this.title = res.tipo_nombre;
          this.infoEventRate = res.regiones;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }


  getUrlDownload(dataUrl: any) {
    this.toasrt.info('Su descarga comienza en un momento');
    const paramsUrl = this.paramsUrlInit();
    this.homeService.downloadDocument(dataUrl, paramsUrl);
  }


}
